import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../../services/api/API";
import { showCustomAlert } from "../../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../../customComponents/CustomLoader";
import { buttonStyle, isFormValid } from "../../../../../../../helpers/common";
import validations from "../../../../../../../helpers/validations";

const EditItem = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [hsncodeOptions, setHsncodeOptions] = useState([]);
  const [taxsetDropdown, setTaxSet] = useState([]);
  const [varientOptions, setVarientOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [itemCategory, setItemcategoryOptions] = useState([]);

  useEffect(() => {
    fetchItemDD();
    fetchUnitDD();
    fetchWarrrantyDD();
    fetchHsncodeDD();
    fetchTaxSetDropdown();
    fetchModelOptions();
    fetchVarientOptions();
    fetchColorOptions();
    fetchTaxSetDropdown();
    fetchItemCategoryOptions();
  }, [formData?.business_partner_id]);

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };
  const fetchVarientOptions = async (makeId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));

      setVarientOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };
  // color options Api
  const fetchColorOptions = async (makeId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchItemCategoryOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/partcategory/ddlpartcategory",
        {
          // itemtype_id: itemtypeid,
          // variant_id:variantIdVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const fetchWarrrantyDD = async () => {
    try {
      const payload = {
        orderBy: "warranty_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/warranty/ddlwarranty",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };
  const fetchUnitDD = async () => {
    try {
      const payload = {
        orderBy: "unit_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/unit/ddlunit", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setUnitOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchItemDD = async () => {
    try {
      const payload = {
        orderBy: "item_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/itemtype/addItemDDL",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.itemtype,
        value: product.itemtype_id,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/tax/ddltax",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, "VARIANTDATA");

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const fetchProductItemEdit = async () => {
    try {
      const response = await axiosInstance.get(`/item/edit/${data.item_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response?.data?.data?.data[0];
      const transformedData = {
        model: fetchedData.model_id,
        variant: fetchedData?.variant_id,
        color: fetchedData?.colour_id,
        itemType: fetchedData.itemtype_id,
        itemCode: fetchedData.item_code,
        purchasePrice: fetchedData.purchase_price,
        sellingPrice: fetchedData.selling_price,
        warranty: fetchedData.warranty_id,
        hsnCode: fetchedData.hsnCode_id,
        unitQuantity: fetchedData.Unit_id,
        taxid: fetchedData?.tax_id,
        // status: fetchedData.status === "Active" ? 1 : 0 ,
        status: fetchedData.status === "Active" ? true : false,
        uploadImage: fetchedData?.image_path,
        itemCategory: fetchedData?.category_id,
        itemName: fetchedData?.item_name,
      };
      setFormData(transformedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Form validation logic
    ItemInputs.forEach((field) => {
      if (field.validation) {
        if (field.name === "status" && formData.status === 0) {
          // Specific validation logic for status field if needed
        } else if (field.validation.required && !formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (
      formData.purchasePrice &&
      formData.sellingPrice &&
      Number(formData.purchasePrice) > Number(formData.sellingPrice)
    ) {
      errors.purchasePrice =
        "Purchase Price cannot be greater than Selling Price";
      isValid = false;
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // SweetAlert confirmation before API call
    showCustomAlert({
      title: "Confirmation",
      text: "Are you sure you want to update this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      callback: async () => {
        try {
          setLoading(true);

          // Create FormData object
          const formDataPayload = new FormData();
          formDataPayload.append("item_name", formData.itemName);
          formDataPayload.append("category_id", formData.itemCategory);
          formDataPayload.append("itemtype_id", formData.itemType);
          formDataPayload.append("item_code", formData.itemCode);
          formDataPayload.append("selling_price", formData.sellingPrice);
          formDataPayload.append("purchase_price", formData.purchasePrice);
          formDataPayload.append("model_id", formData.model || 0);
          formDataPayload.append("variant_id", formData.variant || 0);
          formDataPayload.append("colour_id", formData.color || 0);
          formDataPayload.append("warranty_id", formData.warranty);
          formDataPayload.append("hsnCode_id", formData.hsnCode);
          formDataPayload.append("Unit_id", formData.unitQuantity);
          formDataPayload.append("tax_id", formData.taxid);
          formDataPayload.append("status", formData.status === true ? 1 : 0);
          // status: formData.status === true ? 1 : 0,

          // Append image file only if it's changed
          if (
            formData.uploadImage &&
            formData.uploadImage !== data.item_image
          ) {
            formDataPayload.append("item_image", formData.uploadImage);
          }

          const response = await axiosInstance.patch(
            `/item/update/${data.item_id}`,
            formDataPayload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          // Success alert after update
          showCustomAlert({
            title: "Success",
            text: "Item updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
            callback: () => {
              navigate("/admin/manage-product/item"); // Navigate after user clicks OK
            },
          });
        } catch (error) {
          const errorMessage =
            error.response?.data?.data?.message ||
            error.response?.data?.message ||
            "An error occurred while processing your request.";

          showErrorAlert({
            title: errorMessage || "",
            text: "Something went wrong",
            // callback: () => {
            //   // Optional: code to execute after confirming the alert
            //   console.log("Error alert confirmed");
            // },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  useEffect(() => {
    fetchProductItemEdit();
  }, []);
  const fetchHsncodeDD = async () => {
    try {
      const payload = {
        orderBy: "hsncode_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/hsncode/ddlhsncode",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setHsncodeOptions(options);
    } catch (error) {
      console.error("Error hsncode options:", error);
    }
  };

  const ItemInputs = [
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      options: modelOptions,
      validation: {
        // required: true,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "variant",
      label: "Variant",
      type: "dropdown",
      // required: true,
      options: varientOptions,
      validation: {
        // required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "color",
      label: "Color",
      type: "dropdown",
      // required: true,
      options: colorOptions,
      // validation: {
      //   required: true,
      // },
      gridClass: "col-lg-4",
    },
    {
      name: "itemName",
      label: "Item Name",
      placeholder: "Enter Item Name",
      type: "text",
      required: true,
      // disabled: true,
      validation: validations.itemName({ required: true }),
      // validation: {
      //   required: true,

      //   minLength: 3,
      //   maxLength: 40,

      //   // Enforces 3–40 chars + allowed characters + at least one alphanumeric
      //   pattern: /^(?=.{3,40}$)(?=.*[A-Za-z0-9])[A-Za-z0-9-\s]+$/,

      //   message:
      //     "Item Name must be 3–40 characters long and can contain only letters, numbers, spaces, and hyphens (-)",
      // },
      gridClass: "col-lg-4",
    },
    {
      name: "itemType",
      label: "Item Type",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "itemCode",
      label: "Item Code",
      placeholder: "Enter Item Code",
      type: "text",
      // required: true,
      // validation: {
      //   required: true,
      // },
      gridClass: "col-lg-4",
      validation: {
        // required: true,
        maxLength: 10,
      },
    },
    {
      name: "purchasePrice",
      label: "Purchase Price",
      placeholder: "Enter Purchase Price",
      type: "number",
      isDecimal: true,
      required: true,
      validation: validations.price({ minLength: 1, required: true }),
      // validation: {
      //   required: true,

      //   minLength: 2,
      //   maxLength: 6,

      //   // Enforces total length 4–10 + digits with optional decimal (up to 2 places)
      //   // pattern: /^(?=.{4,6}$)\d+(\.\d{1,2})?$/,
      //   pattern: /^\d{2,6}$/,
      //   message:
      //     "Purchase Price must be 2–6 digits long and contain only numeric values",
      // },
      gridClass: "col-lg-4",
    },
    {
      name: "sellingPrice",
      label: "Selling Price",
      placeholder: "Enter Selling Price",
      type: "number",
      isDecimal: true,
      validation: validations.price({ minLength: 1, required: true }),
      // validation: {
      //   required: true,

      //   minLength: 2,
      //   maxLength: 6,

      //   // Enforces total length 4–10 + digits with optional decimal (up to 2 places)
      //   // pattern: /^(?=.{4,6}$)\d+(\.\d{1,2})?$/,
      //   pattern: /^\d{2,6}$/,
      //   message:
      //     "Selling Price must be 2–6 digits long and contain only numeric values",
      // },
      // maxLength: 13, // Maximum length restriction
      required: true,
      gridClass: "col-lg-4",
    },

    {
      name: "warranty",
      label: "Warranty",
      type: "dropdown",
      // required: true,
      options: warrantyOptions,
      validation: {
        // required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "itemCategory",
      label: "Item Category",
      type: "dropdown",
      required: true,
      options: itemCategory,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "taxid",
      label: "Tax",
      type: "dropdown",
      required: true,
      options: taxsetDropdown,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "hsnCode",
      label: "HSN Code",
      //placeholder: "Enter HSN Code",
      type: "dropdown",
      options: hsncodeOptions,
      validation: {
        required: true,
        // pattern: /^[0-9\s]*$/,
        //message: "Only Digits are allowed*",
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "unitQuantity",
      label: "Unit",
      type: "dropdown",
      required: true,
      options: unitOptions,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "uploadImage",
      label: "Upload",
      type: "file",
      required: true,
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate('/admin/manage-product/item')}
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Item</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Item Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={ItemInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(ItemInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  ItemInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditItem;
